import axios from 'axios'
import React, { useEffect, useState } from 'react'

export const useFirmaContratada = () => {

     
    const [firmaContratada, setFirmaContratada] = useState('checking')

     const getFirmaContratada = async () => {

        const conid = localStorage.getItem('conid')

          try {

            const response = await axios.post(`${process.env.REACT_APP_API_URL_BACK}api/helpers/consultarDatosConid`,{conid})
    
            const [ data ] = response.data
            const {empid,sid} = data

            const resp = await axios.post(`${process.env.REACT_APP_API_URL_BACK}api/helpers/firmaContratada`, {
                empid,sid
              })

  

          setFirmaContratada(resp.data[0].firmadigital)
           
          } catch (error) {
            console.log(error)
          }





     }


     useEffect(() => {
        getFirmaContratada()
     }, [])
     



  return {firmaContratada}
}
